import { customerExperiencesNavigationResource } from '@jira/router-resources__customer-experiences-navigation/src/customerExperiencesNavigationResource.tsx';
import { csmGlobalCustomerAccessSettingsResource } from '@jira/router-resources__admin-pages-csm-customer-access/src/csmGlobalCustomerAccessSettingsResource.tsx';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { jsmGlobalCustomerAccessSettingsResource } from '@jira/router-resources__admin-pages-jsm-customer-access/src/jsmGlobalCustomerAccessSettingsResource.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsCustomerAccessRoute } from '@jira/router-routes__help-center-settings-routes/src/helpCenterSettingsCustomerAccessRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import {
	HelpCenterSettingsCustomerAccess,
	LazyHelpCenterSettingsCustomerAccess,
} from './ui/customer-access/index.tsx';

export const helpCenterSettingsCustomerAccessRouteEntry: Route = createEntry(
	helpCenterSettingsCustomerAccessRoute,
	() => ({
		perfMetricKey: 'help-center-settings.customer-access',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
		},
		// eslint-disable-next-line no-restricted-syntax
		component: HelpCenterSettingsCustomerAccess,
		forPaint: [LazyAtlassianNavigation, LazyHelpCenterSettingsCustomerAccess],
		resources: [
			...getServiceDeskSettingsResources(),
			jsmGlobalCustomerAccessSettingsResource,
			resourceWithCondition(
				() => fg('csm_customer_access_jsm_separation'),
				csmGlobalCustomerAccessSettingsResource,
			),
			customerExperiencesNavigationResource,
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
